'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@prism/modal';
import classNames from 'classnames';
import PrismButton from './../button/prismButton';
import { MODAL_SIZES } from './../../../constants';

class PrismModal extends React.PureComponent {
    static propTypes = {
        toggle: PropTypes.func,
        headerTitle: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        backdrop: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.oneOf(['static'])
        ]),
        headerClassName: PropTypes.string,
        footerContent: PropTypes.node,
        footerClassName: PropTypes.string,
        className: PropTypes.string,
        bodyClassName: PropTypes.string,
        contentClassName: PropTypes.string,
        size: PropTypes.string,
        isOpen: PropTypes.bool,
        cancelButtonConfig: PropTypes.shape({
            text: PropTypes.string,
            onClick: PropTypes.func,
            className: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.array,
                PropTypes.object
            ]),
            visible: PropTypes.bool,
            disabled: PropTypes.bool
        })
    };

    static defaultProps = {
        size: 'sm',
        isOpen: false,
        cancelButtonConfig: {},
        backdrop: true
    };

    render() {
        const {
            isOpen,
            toggle,
            headerTitle,
            headerClassName: propsHeaderClassName,
            footerContent,
            footerClassName: propsFooterClassName,
            className,
            bodyClassName: propsBodyClassName,
            contentClassName: propsContentClassName,
            size,
            children,
            cancelButtonConfig,
            backdrop
        } = this.props;

        const modalClassNames = classNames('in', 'prism-modal');
        const bodyClassNames = classNames('prism-modal__body', propsBodyClassName);
        const footerClassNames = classNames('prism-modal__footer', propsFooterClassName);
        const headerClassNames = classNames('prism-modal__header',  propsHeaderClassName);
        const contentClassNames = classNames(
            'prism-modal__content',
            {
                'prism-modal__content_large-size': size === MODAL_SIZES.LARGE
            },
            propsContentClassName
        );

        const backdropTransition = {
            timeout: 0
        };
        const cancelButton = cancelButtonConfig.visible && (
            <PrismButton
                className={cancelButtonConfig.className}
                type="button"
                onClick={cancelButtonConfig.onClick}
                disabled={cancelButtonConfig.disabled}
            >
                {cancelButtonConfig.text || 'cancel'}
            </PrismButton>
        );

        return (
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                wrapClassName="prism-sandbox"
                contentClassName={contentClassNames}
                className={className}
                modalClassName={modalClassNames}
                size={MODAL_SIZES.SMALL}
                backdropTransition={backdropTransition}
                backdrop={backdrop}
            >
                {headerTitle && (
                    <Modal.Header
                        tag="h4"
                        toggle={toggle}
                        className={headerClassNames}
                    >
                        {headerTitle}
                    </Modal.Header>
                )}
                <Modal.Body className={bodyClassNames}>{children}</Modal.Body>
                {(cancelButton || footerContent) && (
                    <Modal.Footer className={footerClassNames}>
                        {cancelButton}
                        {footerContent}
                    </Modal.Footer>
                )}
            </Modal>
        );
    }
}

export default PrismModal;
